"use client";

// src/react-syntax-highlighter.tsx
import SyntaxHighlighter, {
  Prism,
  PrismAsync,
  PrismAsyncLight,
  PrismLight,
  Light,
  LightAsync
} from "react-syntax-highlighter";
import { jsx } from "react/jsx-runtime";
var makeMakeSyntaxHighlighter = (SyntaxHighlighter2) => (config) => {
  const PrismSyntaxHighlighter = ({
    components: { Pre, Code },
    language,
    code
  }) => {
    return /* @__PURE__ */ jsx(
      SyntaxHighlighter2,
      {
        PreTag: Pre,
        CodeTag: Code,
        ...config,
        language,
        children: code
      }
    );
  };
  PrismSyntaxHighlighter.displayName = "PrismSyntaxHighlighter";
  return PrismSyntaxHighlighter;
};
var makeSyntaxHighlighter = makeMakeSyntaxHighlighter(SyntaxHighlighter);
var makePrismSyntaxHighlighter = makeMakeSyntaxHighlighter(Prism);
var makePrismAsyncSyntaxHighlighter = makeMakeSyntaxHighlighter(PrismAsync);
var makePrismAsyncLightSyntaxHighlighter = makeMakeSyntaxHighlighter(PrismAsyncLight);
var makePrismLightSyntaxHighlighter = makeMakeSyntaxHighlighter(PrismLight);
var makeLightSyntaxHighlighter = makeMakeSyntaxHighlighter(Light);
var makeLightAsyncSyntaxHighlighter = makeMakeSyntaxHighlighter(LightAsync);
export {
  makeLightAsyncSyntaxHighlighter,
  makeLightSyntaxHighlighter,
  makePrismAsyncLightSyntaxHighlighter,
  makePrismAsyncSyntaxHighlighter,
  makePrismLightSyntaxHighlighter,
  makePrismSyntaxHighlighter,
  makeSyntaxHighlighter
};
//# sourceMappingURL=react-syntax-highlighter.js.map